/* Stallion Gear — homepage redesign (Twiz). Small behaviours for sg-* sections. */
(function () {
  if (window.__sgThemeInit) return;
  window.__sgThemeInit = true;

  function store(fn) { try { return fn(); } catch (e) { return null; } }

  /* Header height -> --sg-header-h (used by hero "pull under header") */
  function measureHeader() {
    var h = document.querySelector('.sg-header-section');
    if (!h) return;
    var nav = h.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--sg-header-h', Math.round(nav) + 'px');
  }

  /* Women / Men tabs (synced across sections that opt in) */
  function setGender(rail, gender) {
    rail.setAttribute('data-active', gender);
    rail.querySelectorAll('[data-sg-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-sg-tab') === gender ? 'true' : 'false');
    });
    var track = rail.querySelector('.sg-rail__track');
    if (track) track.scrollLeft = 0;
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.sg-nav__search[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });

    var tab = e.target.closest('[data-sg-tab]');
    if (tab) {
      var rail = tab.closest('.sg-rail');
      var gender = tab.getAttribute('data-sg-tab');
      if (rail && rail.hasAttribute('data-sg-sync')) {
        document.querySelectorAll('.sg-rail[data-sg-sync]').forEach(function (r) { setGender(r, gender); });
      } else if (rail) {
        setGender(rail, gender);
      }
      return;
    }

    var close = e.target.closest('[data-sg-ann-close]');
    if (close) {
      var bar = close.closest('.sg-announcement');
      if (bar) {
        bar.hidden = true;
        store(function () { sessionStorage.setItem('sg-ann-hidden-' + bar.dataset.key, '1'); });
        measureHeader();
      }
      return;
    }

    var burger = e.target.closest('[data-sg-burger]');
    if (burger) {
      var nav = burger.closest('.sg-nav');
      var open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var arrow = e.target.closest('[data-sg-hero-step]');
    if (arrow) {
      var hero = arrow.closest('.sg-hero');
      heroGo(hero, Number(hero.dataset.index || 0) + Number(arrow.getAttribute('data-sg-hero-step')));
    }
  });

  /* Hero slides */
  function heroGo(hero, i) {
    var slides = hero.querySelectorAll('.sg-hero__slide');
    if (!slides.length) return;
    var n = slides.length;
    i = Math.max(0, Math.min(n - 1, i));
    hero.dataset.index = i;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    var prev = hero.querySelector('[data-sg-hero-step="-1"]');
    var next = hero.querySelector('[data-sg-hero-step="1"]');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === n - 1;
  }
  function heroAutoplay(hero) {
    var secs = Number(hero.dataset.autoplay || 0);
    if (!secs || hero.__sgTimer) return;
    hero.__sgTimer = setInterval(function () {
      var n = hero.querySelectorAll('.sg-hero__slide').length;
      heroGo(hero, (Number(hero.dataset.index || 0) + 1) % n);
    }, secs * 1000);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.sg-announcement[data-key]').forEach(function (bar) {
      if (bar.dataset.dismissible === 'true' && store(function () { return sessionStorage.getItem('sg-ann-hidden-' + bar.dataset.key); })) bar.hidden = true;
    });
    root.querySelectorAll('.sg-hero').forEach(function (h) { heroGo(h, Number(h.dataset.index || 0)); heroAutoplay(h); });
    measureHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('.sg-hero__slide');
    if (slide) {
      var hero = slide.closest('.sg-hero');
      heroGo(hero, Array.prototype.indexOf.call(hero.querySelectorAll('.sg-hero__slide'), slide));
    }
    var card = e.target.closest && e.target.closest('[data-sg-group]');
    if (card) {
      var g = card.getAttribute('data-sg-group');
      var rail = card.closest('.sg-rail');
      if (rail && (g === 'women' || g === 'men')) setGender(rail, g);
    }
  });
})();